export const VIN_WMI_STATUS_COLUMNS = Object.freeze([
  { prop: 'DiagMod', label: '原厂类型', width: '200' },
  { prop: 'make', label: '品牌', width: '160' },
  { prop: 'country', label: '国家', width: '160' },
  { prop: 'region', label: '区域', width: '180' },
  { prop: 'Year', label: '年款', width: '100' },
  { prop: 'scanCount', label: '收集次数', width: '100' },
  { prop: 'dateStr', label: '最近一次更新', width: '200' },
])

export function buildVinWmiMobileRows(item) {
  return [
    { key: 'make', label: '品牌', value: item?.make },
    { key: 'country', label: '国家', value: item?.country },
    { key: 'region', label: '区域', value: item?.region },
  ]
}

export function buildVinDiagModePresentation(item) {
  const rawText = String(item?.DiagMod || '').trim() || '-'
  const modes = rawText.split('/').map((mode) => mode.trim())
  const text = modes.join(' / ')
  let hint = String(item?.DiagModHint || '').trim()
    .replaceAll('未检测到FN', '离线库未识别 PCM 零件号（ExistsFN=0）')
    .replaceAll('已检测到FN', '离线库已识别 PCM 零件号（ExistsFN=1）')

  // 兼容旧接口的混合结果；只展开已有结果，不在前端判断 VIN 或年款。
  if (!hint && modes.length === 2 && modes.every((mode) => ['在线结构', '离线结构', '江铃软件'].includes(mode))) {
    hint = `离线库未识别 PCM 零件号（ExistsFN=0）：${modes[0]}；离线库已识别 PCM 零件号（ExistsFN=1）：${modes[1]}`
  }
  const conditions = hint.split(/[；\n]+/).map((condition) => condition.trim()).filter(Boolean)

  return {
    text,
    hint,
    hasHint: hint.length > 0,
    conditions,
  }
}

export function buildVinDiagModeChangeRequest(vin, deliver, target) {
  const Vin = String(vin ?? '').trim()
  const deliverId = String(deliver ?? '').trim()
  if (Vin.length !== 17 || !/^\d+$/.test(deliverId) || Number(deliverId) <= 0) {
    throw new Error('VIN或模板数据无效')
  }
  if (target !== 'online' && target !== 'offline') {
    throw new Error('诊断目标无效')
  }

  // 兼容现有 ChangeDiagMod 接口：IDS 请求写 MYFDRS，FDRS 请求写 IDS。
  // 固定传入目标对应的请求值，避免根据当前显示结果反向切换。
  return { Vin, deliver: deliverId, DiagMod: target === 'online' ? 'IDS' : 'FDRS' }
}

// 诊断分支字段的展示格式化：
// - null / undefined / 空字符串 显示为 '-'
// - 0 是合法值（收集次数为 0），必须显示为 0，不能因为 falsy 被吞掉
// - 其余值原样显示（含字符串 "NULL"、年份数字等）
export function formatVinWmiFieldValue(value) {
  if (value === null || value === undefined) return '-'
  const text = String(value).trim()
  return text === '' ? '-' : text
}
